import { render } from "./Tema.vue?vue&type=template&id=58f23aeb"
import script from "./Tema.vue?vue&type=script&lang=js"
export * from "./Tema.vue?vue&type=script&lang=js"

import "./Tema.vue?vue&type=style&index=0&id=58f23aeb&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__